interface RootStoreAccessor {
  setValidationErrorVisible: (isVisible: boolean) => void;
  setValidationErrorMessage: (message: string) => void;
}

let rootStoreAccessor: RootStoreAccessor | null = null;

export const setRootStoreAccessor = (store: RootStoreAccessor) => {
  rootStoreAccessor = store;
};

export const getRootStoreAccessor = () => {
  return rootStoreAccessor;
};
